import type { ShopOrderDetail, ShopOrderRefundAction } from "@/api/shopOrder";

export type OrderOperation = "deliver" | ShopOrderRefundAction;

export function requiresReturnShipping(detail: ShopOrderDetail): boolean {
  const { order, aftersale } = detail;
  const delivered = order.deliveryStatus === 1 || Boolean(order.deliveryTime);
  const hasLogistics = Boolean(order.logisticsCode?.trim());
  return aftersale?.aftersaleType === 2 && (delivered || hasLogistics || Boolean(order.receiveTime)) &&
    !(delivered && !hasLogistics);
}

export function availableOrderOperations(goodsType: number | undefined, detail: ShopOrderDetail): OrderOperation[] {
  if (goodsType !== 1) return [];
  const { order, aftersale } = detail;
  if (order.orderStatus === 1) return ["deliver"];
  if (aftersale?.id == null) return [];
  if (order.orderStatus === 5 && aftersale.aftersaleStatus === 0) return ["confirmRefund", "rejectRefund"];
  if (order.orderStatus !== 6 || ![1, 2].includes(aftersale.aftersaleStatus)) return [];
  const canRefund = !requiresReturnShipping(detail) || (aftersale.aftersaleType === 2 &&
    aftersale.aftersaleStatus === 2 && Boolean(aftersale.returnLogisticsCompany?.trim()) &&
    Boolean(aftersale.returnLogisticsCode?.trim()));
  return canRefund ? ["confirmReceive", "refuseRefund"] : ["refuseRefund"];
}

export function orderOperationLabel(action: OrderOperation, detail?: ShopOrderDetail | null): string {
  switch (action) {
    case "deliver": return "发货";
    case "confirmRefund": return "同意退款申请";
    case "rejectRefund": return "驳回退款申请";
    case "confirmReceive": return detail && !requiresReturnShipping(detail) ? "确认退款" : "确认收货并退款";
    case "refuseRefund": return "不予退款";
  }
}

const aftersaleStatuses = ["待审核", "审核通过待退货", "已退货待退款", "退款完成", "拒绝售后", "已取消"];
export function aftersaleStatusLabel(detail: ShopOrderDetail): string {
  const aftersale = detail.aftersale;
  if (!aftersale) return "-";
  if (!requiresReturnShipping(detail) && aftersale.aftersaleStatus === 1) return "审核通过待退款";
  return aftersaleStatuses[aftersale.aftersaleStatus] ?? "未知";
}
